import request from '@/utils/request'
// 登录
export const reqLogin = (data) => {
  return request({
    method: 'post',
    url: `/sysoauthuser/login`,
    data
  })
}

// 发送验证码
export const reqSendCode = (phone) => {
  return request({
    method: 'get',
    url: `/user/passport/sendCode/${phone}`,
  })
}

// 注册
export const reqRegister = (data) => {
  return request({
    method: 'post',
    url: `/user/passport/register`,
    data,
  })
}


// 退出登录
export const reqLoginOut = () => {
  return request({
    method: 'get',
    url: '/user/passport/logout',
  })
}
// 获取个人信息
export const GetCustomerInfoById = (params) => {
  return request({
    method: "get",
    url: `/weChatUserEx/userInfo`,
    params,
  });
};
